import type { CTATypeCF } from '@/types';
import type { PaidLanderFields } from '../PaidLander.types';
import Confirmation from './Confirmation';

export default function SuccessStep({
  successScreenHeader,
  successScreenDescription,
  successScreenImage,
  successScreenImageAltText,
  isVisible,
  successCta,
  isOnDark = false,
  fixedGrid = false,
  reverseLayout = false,
  hideImageOnMobile = false,
}: PaidLanderFields & { isVisible: boolean }) {
  return (
    <Confirmation
      heading={successScreenHeader}
      description={successScreenDescription}
      hideImageOnMobile={hideImageOnMobile}
      imageSrc={successScreenImage?.[0]?.preview_url}
      imageAltText={successScreenImageAltText}
      buttonContent={successCta as CTATypeCF}
      isOnDark={isOnDark}
      isVisible={isVisible}
      reverseLayout={reverseLayout}
      fixedGrid={fixedGrid}
    />
  );
}
